import { supabase } from './supabase/supabase-config';

// Bucket privado dos instaladores. Publicado via
// RNPlugin-Plugin/Deployment/publish-installer.ps1.
export const BUCKET = 'bundles';

/**
 * Versao publicada mais recente, ou null se nao houver nenhuma.
 *
 * A RLS de plugin-versions libera leitura para authenticated e anon, entao nao
 * precisa de filtro por usuario aqui.
 */
export async function buscarVersaoAtual() {
  const { data, error } = await supabase
    .from('plugin-versions')
    .select('version, download_url, release_notes, created_at, sha256, virustotal_url')
    .eq('is_latest', true)
    .eq('is_active', true)
    .limit(1);

  if (error) throw error;
  return data?.[0] ?? null;
}

/**
 * Transforma o que esta gravado em download_url num link utilizavel.
 *
 * O banco guarda o CAMINHO dentro do bucket, nao uma URL pronta. A assinatura
 * acontece aqui, no momento do clique, e vale 60 segundos — guardar uma signed
 * URL no banco seria guardar credencial, que vence sem avisar e funciona para
 * qualquer um que receba o link.
 *
 * Quem decide se o download e permitido nao e este codigo: e a policy do storage,
 * que exige assinatura ativa, valida e nao vencida. Esconder o botao no site e
 * conveniencia; o controle esta no servidor.
 *
 * Aceita URL completa para o caso de o instalador passar a ser servido de outro
 * lugar, como uma CDN ou release do GitHub.
 */
export async function gerarLinkDownload(caminhoOuUrl) {
  if (!caminhoOuUrl) throw new Error('Versao sem arquivo associado.');
  if (/^https?:\/\//i.test(caminhoOuUrl)) return caminhoOuUrl;

  const { data, error } = await supabase.storage
    .from(BUCKET)
    .createSignedUrl(caminhoOuUrl, 60);

  if (error) throw error;
  return data.signedUrl;
}

/**
 * Incrementa o contador de downloads da versao, pro painel admin. Best-effort:
 * falha aqui nao pode travar o download em si, so o numero de controle fica
 * impreciso.
 */
export async function registrarDownload(version) {
  if (!version) return;
  const { error } = await supabase.rpc('registrar_download', { p_version: version, p_origem: 'site' });
  if (error) console.error('Falha ao registrar download:', error);
}
